import { useMemo } from "react";
import { Select } from "@narmi/design_system";
import { useTranslatedDueDateOptions } from "byzantine/src/dbbl/businessLogic/modules/alerts";

export interface DueDateSelectorProps {
  label?: string;
  /**
   * The alerts form stores `reminderDaysOffset` as `number | null`
   * (seeded from the API), so this arrives as a number when editing
   * an existing alert.
   */
  value: string | number | null;
  onChange: (value: string) => void;
  error?: string;
  errorText?: string;
}

export default function DueDateSelector({
  label,
  value,
  onChange,
  error,
  errorText,
}: DueDateSelectorProps) {
  const options = useTranslatedDueDateOptions();

  const renderedOptions = useMemo(
    () =>
      options.map((option) => (
        <Select.Item
          key={option.id}
          value={String(option.id)}
          searchValue={option.displayValue}
        >
          {option.displayValue}
        </Select.Item>
      )),
    [options],
  );

  return (
    <Select
      id="due-date-select"
      label={label}
      value={value == null ? undefined : String(value)}
      defaultValue={value == null ? undefined : String(value)}
      onChange={onChange}
      errorText={errorText || error}
    >
      {renderedOptions}
    </Select>
  );
}
